export const EMERGENCY_DTRF = "EMERGENCY_DTRF"
export const EMERGENCY_DTRF_FAIL = "EMERGENCY_DTRF_FAIL"
export const EMERGENCY_DTRF_SUCCESS = "EMERGENCY_DTRF_SUCCESS"
export const EMERGENCY_DTRF_RESET = "EMERGENCY_DTRF_RESET"

export const saveEmergencyDtrf = (params) => {
    return { type: EMERGENCY_DTRF, params }
}
export const saveEmergencyDtrfFail = (response) => {
    return { type: EMERGENCY_DTRF_FAIL, response }
}
export const saveEmergencyDtrfSuccess = (response) => {
    return { type: EMERGENCY_DTRF_SUCCESS, response }
}
export const saveEmergencyDtrfReset = () => {
    return { type: EMERGENCY_DTRF_RESET }
}